export default ({ user }) => user.permissions.can_mark_challenges_as_read;
